/* eslint-disable @next/next/no-img-element */
import React from 'react';
import cn from 'classnames';
import Image from 'next/legacy/image';
import ArrowRight from 'src/common/icons/arrow-right-circle.svg';
import { useRouter } from 'next/router';
import s from './Interlinking.module.scss';
import { StrapiImageTypes } from '../../../../utils/types';

enum LinkType {
  Icon = 'iconLink',
  Arrow = 'arrowLink',
  NoArrow = 'noArrowLink',
  BigIconLink = 'bigIconLink',
}

type LinkItemTypes = {
  label: string;
  id: number | string;
  href: string;
  linkType?: 'internal' | 'external';
  icon?: StrapiImageTypes;
};

type InterlinkingProps = {
  title: string | '';
  data: Array<LinkItemTypes>;
  customStyle?: any;
  type?: LinkType;
};
export function Interlinking({
  title,
  data,
  customStyle = null,
  type = LinkType.NoArrow,
}: InterlinkingProps) {
  const router = useRouter();
  if (!Array.isArray(data)) return null;
  if (data.length === 0) return null;

  return (
    <div
      className={cn(s.root, {
        [s.root_type_icon]: type === LinkType.Icon,
        [s.root_type_noarrow]: type === LinkType.NoArrow,
        [s.root_type_arrow]: type === LinkType.Arrow,
        [s.root_type_bigIcon]: type === LinkType.BigIconLink,
      })}
      style={customStyle}
    >
      <div className={[s.box].join(' ')}>
        {title && (
          <div className={s.title}>
            <h4 className={s.title_text}>{title}</h4>
          </div>
        )}
        <div className={s.body}>
          {data
            .filter(
              (link) => `https://parkplus.io${router.asPath}` !== link.href
            )
            .map((link) => (
              <div key={link?.href} className={s.link_item}>
                {type === LinkType.Arrow && (
                  <div className={s.svg}>
                    <ArrowRight />
                  </div>
                )}
                <div className={s.left}>
                  {(type === LinkType.Icon ||
                    type === LinkType.BigIconLink) && (
                    <button
                      className={s.icon}
                      type="button"
                      onClick={() => router.push(link.href)}
                    >
                      {link?.icon?.data?.attributes ? (
                        <img
                          src={link?.icon?.data?.attributes?.url}
                          alt={link?.icon?.data?.attributes?.alternativeText}
                        />
                      ) : (
                        //@ts-ignore
                        link?.icon?.url && (
                          <img
                            //@ts-ignore
                            src={link?.icon?.url}
                            //@ts-ignore
                            alt={link?.icon?.alternativeText}
                          />
                        )
                      )}
                    </button>
                  )}
                  <a href={link.href}>{link.label}</a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
